export default "__VITE_ASSET__aa060b4d__"